import React from 'react';
import { Theme } from '../../Enums/Theme.enum';
import Button from './Button';

interface Props {
	onClick: () => void;
}
const ConfirmButton: React.FC<Props> = ({ onClick }) => (
	<Button onClick={onClick} title={'base.yes'} theme={Theme.GREEN} />
);

export default ConfirmButton;
